import { render } from "./FormVerify.vue?vue&type=template&id=fab2ea4c&scoped=true"
import script from "./FormVerify.vue?vue&type=script&lang=js"
export * from "./FormVerify.vue?vue&type=script&lang=js"

import "./FormVerify.vue?vue&type=style&index=0&id=fab2ea4c&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\sport.yanhuotiyu.com焱火pc端web网站\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fab2ea4c"]])

export default __exports__